<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="flex xs6">
          <va-input :value="term" placeholder="Search" removable>
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
        </div>
        <slot></slot>
      </div>
    </div>

    <va-data-table :fields="fields" :data="data">
      <template slot="add" slot-scope="props">
        <va-button small color="primary" class="ma-0">+</va-button>
      </template>
      <template slot="delete" slot-scope="props">
        <va-button small color="danger" class="ma-0" @click="deleteItem(props.rowData)">Delete</va-button>
      </template>
    </va-data-table>
  </div>
</template>
<script>
export default {
  props: {
    fields: Array,
    data: Array,
  },
  methods: {
    deleteItem(data){
      this.$emit('deleteItem', data)
    }
  },
  data () {
    return {
      term: '',
    }
  },
  created () {},
}
</script>
<style scoped>
</style>
